import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import DEFINE, { PATHS } from "../../../../constants/Define";
import * as Func from '../../../../helpers/functions';
import {
    PageListComponent, HeaderListComponent,
} from "../../common/component/Index";
import Ripple from '../../common/component/Ripple';
import TicketAssignConfigList from './TicketAssignConfigList';
import { get, omit } from 'lodash';

let permissionActions = [];
export default class TicketAssignConfigs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {}
        };
    }

    componentDidMount() {
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TICKET_ASSIGN_CONFIG);
        this.getTicketAssignConfigs();
    }

    render() {
        const { t, ticketState } = this.props;
        const { isFetching, ticketAssignConfigs } = ticketState;
        const { totalCount, totalPage, pageIndex, pageSize } = ticketState.ticketAssignConfigParams
        const pagination = { totalCount, totalPage, pageIndex, pageSize };
        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'tickets'}
                        titleHeader={t('navigation.ticketAssignConfigs')}
                        componentRight={
                            <Fragment>{
                                permissionActions && permissionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.TICKET_ASSIGN_CONFIG.CREATE.path}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <TicketAssignConfigList
                        loading={isFetching}
                        permissions={permissionActions}
                        ticketAssignConfigs={ticketAssignConfigs}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDelete={this.onDeleteTicketAssignConfig}
                    />
                </PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getTicketAssignConfigList(newFilters);
    };

    getTicketAssignConfigs(filters) {
        if (!filters) filters = this.getCurrentFilters();
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getTicketAssignConfigList(filters);
    }

    getCurrentFilters = (removeFields) => {
        const { ticketState } = this.props;
        const filters = omit(ticketState.ticketAssignConfigParams, [
            'tickets', 'myTickets', 'ticketAssignConfigs', 'detail', 'isFetching', 
            'isFetchingDetail', 'isFetchingTranslate', 'isFetchingConfig',
            'totalCount', 'totalPage',
        ]);
        return removeFields ? omit(filters, removeFields) : filters;
    }

    onDeleteTicketAssignConfig = (ticketAssignConfig) => {
        this.props.deleteTicketAssignConfig(ticketAssignConfig, this.state.filters)
    }

}

TicketAssignConfigs.defaultProps = {

}
